import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import HeavySearchpageForm from '@components/search/forms/HeavySearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'
import { HEAVY_LINK_BASE } from '@constants/searchFormLinks'

import MakeModelLinks from '@components/links/MakeModelLinks'
import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'
import SEARCH_HEAVY_LINKS from '@components/frontpage/constants/searchHeavyLinks'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import BlogSample from '@components/blog/components/BlogSample'

import dbConnect from 'db/dbConnect'
import listHeavyAds from 'db/repo/listAds/listAdsHeavy'
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import substituteSearchQuery from '@pages/search/functions/substituteSearchQuery'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'
import getMakeModelLinks from '@pages/search/server/getMakeModelLinks'
import makeSearchHeavyLinks from '@components/frontpage/functions/makeSearchHeavyLinks'
import appendAdvancedSearchText from 'src/seo/server/appendAdvancedSearchText'
import heavyFallbackSeo from 'src/seo/server/fallbackSeoHeavy'
import blogSample from 'db/repo/blogSample'

import getRidOfCategoryLinkForConsecutivePages from '@components/frontpage/functions/getRidOfCategoryLinkForConsecutivePages'

const DEFAULT_HEADINGS = {
    h1: 'Samochody ciężarowe',
    h2: 'Auta ciężarowe najnowsze oferty sprzedaży zobacz w kategorii samochody ciężarowe - Dostawczaki.pl',
}

export default function HeavySearchpage ({
    articleSample,
    cubeLinks,
    locationObjectLd,
    makeModelLinks,
    offers,
    pagination,
    query,
    seo,
 }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile,
        seo.articleFileImage, `${query.marka || ''} ${query.model || ''} - samochody ciężarowe - Dostawczaki.pl`)

    const queryParamCount = Object.keys(query||{}).length
    const makeModelLinkProps = {
        links: makeModelLinks,
        linkBase: HEAVY_LINK_BASE,
        make: query.marka,
        prefix: 'Dostawcze',
        show: Boolean(queryParamCount === 0 || queryParamCount === 1 && query.marka),
        titles: ['Samochody ciężarowe marki', 'Ciężarowe modele']
    }

    return (
        <Layout>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/samochody-ciezarowe"
                buy={false}
                category="Samochody ciężarowe"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={320}
                src="/backgrounds/samochody-dostawcze-uzywane-i-nowe-na-sprzedaz.webp"
                alt="Samochody ciężarowe nowe i używane"
                z={7}>

                <HeavySearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    above: <MakeModelLinks {...makeModelLinkProps} viewOnMobile={false} />,
                    below: <>
                        {seoArticleBody}
                        <MakeModelLinks {...makeModelLinkProps} />
                    </>,
                    offers,
                    pagination, }} />

            </ViewContextProvider>

            <BlogSample articles={articleSample} />
            <FrontpageLinks sections={cubeLinks} />
            <FAQ qa={seo.faqFile} page="hezvy_searchpage" />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listHeavyAds(query, { cookies })
    const articleSample = await blogSample(4, query, {
        tags: [
            'Ciężarówki',
            'ciężarówki',
        ],
    }, false)

    const cubeLinks = getRidOfCategoryLinkForConsecutivePages(
        await makeSearchHeavyLinks(query, '/samochody-ciezarowe', 'Ciężarowe', SEARCH_HEAVY_LINKS),
        query,
    )

    return {
        props: {
            articleSample,
            cubeLinks,
            query,
            offers: ads,
            pagination,
            seo: appendAdvancedSearchText(await useUrlSeo({
                resolvedUrl: context.resolvedUrl,
                query,
                baseUrl: '/samochody-ciezarowe',
                substituteQuery: substituteSearchQuery(query),
                defaultSeo: {
                    ...DEFAULT_HEADINGS,
                    title: DEFAULT_HEADINGS.h1,
                    description: DEFAULT_HEADINGS.h2,
                },
                fallbackFunction: heavyFallbackSeo,
            }), query, true),
            locationObjectLd: locationLdSchema(query.lokalizacja),
            makeModelLinks: await getMakeModelLinks('ciezarowe', query),
        }
    }
}